/* eslint-disable react/style-prop-object */
import React from "react";

import { formatDate } from "../../../../JsHelpers/DateFormat";
import trans from "../../../../utils";
import TrackedSelectedRows from "./TrackedSelectedRows";
import { Tag } from "antd";

export default function TrackedSelectedStatus({ position, device }) {
	const { formattedDate, formattedTime } = formatDate(device?.lastUpdate);

	return (
		<>
			<div className="object-working-status">
				<div className="object-status-details">
					<TrackedSelectedRows
						title={trans("GPS status")}
						item={`${
							device?.status === "online"
								? `${trans("Available")}`
								: `${trans("UnAvailable")}`
						}`}
					/>
				</div>
				<div className="object-status-details">
					<TrackedSelectedRows
						title={trans("Accuracy")}
						item={
							position?.accuracy
								? `${Math.round(position?.accuracy)}`
								: `${trans("N/A")}`
						}
					/>
				</div>
				<div className="object-status-details">
					<TrackedSelectedRows
						title={trans("connectivity")}
						item={
							<Tag color={device?.status === "online" ? "green" : "red"}>
								{device?.status === "online"
									? `${trans("Connected")}`
									: `${trans("Disconnected")}`}
							</Tag>
						}
					/>
				</div>
				<div className="object-status-details">
					<TrackedSelectedRows
						title={trans("Latitude")}
						item={position?.latitude ? `${position?.latitude}` : "33"}
					/>
				</div>
				<div className="object-status-details">
					<TrackedSelectedRows
						title={trans("Longitude")}
						item={position?.longitude ? `${position?.longitude}` : "30"}
					/>
				</div>
				<div className="object-status-details">
					<TrackedSelectedRows
						title={trans("last update")}
						item={
							device?.lastUpdate
								? `${formattedDate + " " + formattedTime}`
								: `${trans("N/A")}`
						}
					/>
				</div>
			</div>
		</>
	);
}
